// extracted by mini-css-extract-plugin
module.exports = {"root":"u-tooltip__3LzpXjeY","arrow":"u-tooltip_arrow__3LzpXjeY","body":"u-tooltip_body__3LzpXjeY"};